import {Box, Clickable, getValueByDevice, useDevice} from 'platform/foundation';
import 'swiper/css';
import {Swiper, SwiperSlide} from 'swiper/react';

import {type ComponentType} from 'react';

import {type SlideImage} from '../../types/SlideImage';
import {AdaptiveImageDc} from '../AdaptiveImageDc/AdaptiveImageDc';

interface CarouselSwiperProps {
  CarouselButtonComponent: ComponentType<{variant: 'right' | 'left'}>;
  images: SlideImage[];
  onInspectImage: (slideShowItem: SlideImage) => void;
}

export const CarouselSwiper = (props: CarouselSwiperProps) => {
  const device = useDevice();
  const slidesPerView = getValueByDevice(device, 1, 2.5, 2.5, 3);
  const CarouselButton = props.CarouselButtonComponent;

  return (
    <Box>
      <Swiper autoHeight={false} navigation={true} slidesPerView={slidesPerView} spaceBetween={4}>
        {props.images.map((image) => (
          <SwiperSlide key={image.id}>
            <Clickable onClick={() => props.onInspectImage(image)}>
              <AdaptiveImageDc fit="cover" url={image.resizeUrl} />
            </Clickable>
          </SwiperSlide>
        ))}
        <CarouselButton variant="left" />
        <CarouselButton variant="right" />
      </Swiper>
    </Box>
  );
};
